import { useForm, Controller } from "react-hook-form";
import React, { useState, useEffect } from "react";
import Grid from "@mui/material/Grid";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Checkbox from "@mui/material/Checkbox";
import Button from "@mui/material/Button";
import MDBox from "../../../components/MDBox/index";
import MDInput from "components/MDInput";
import { adminUserFormValidation } from "../../../util/validations/adminPanelValidation";
import SelectDropDown from "./../../../examples/DropDown/index";
import {
  DialogContent,
  Typography,
  FormControlLabel,
  FormGroup,
  CircularProgress,
  Link,
} from "@mui/material";
import { useNavigate, useParams } from "react-router-dom";
import { yupResolver } from "@hookform/resolvers/yup";
import { updateAdminUSer } from "../Redux/actionCreator";
import { useDispatch, useSelector } from "react-redux";
import { getAdminUserByIdService } from "services/adminServices";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import { ArrowBackIos } from "@mui/icons-material";
import Moment from "moment";
import { setRoleType } from "layouts/events/Redux/actionCreator";
import SelectDropDownNew from "examples/DropDownNew";
const label = { inputProps: { "aria-label": "Checkbox demo" } };

const AdminUserForm = () => {
  const params = useParams();
  const [passwordButton, setPasswordButton] = useState(true);

  const selectOptions = [
    {
      key: "Company",
      value: "Company",
    },
  ];
  const ID = params.userName;
  //const ID = window.location.href.split("admin")[1].split("/")[1];
  // const ID = window.location.href.split("admin")[2].split("/")[1];

  const roleOptions = [
    {
      key: "Company",
      value: "Company",
    },
  ];

  const [responseData, setResponseData] = useState([]);
  const [expandedModules, setExpandedModules] = useState({});

const toggleModule = (moduleName) => {
  setExpandedModules((prev) => ({
    ...prev,
    [moduleName]: !prev[moduleName],
  }));
};
const getModulePermissionKeys = (section) => {
  const moduleKey = section.module.toLowerCase().replace(/\s+/g, "_");
  const keys = [];

  section.items.forEach((item) => {
    if (typeof item === "object" && item.subItems) {
      const parentKey = item.name.toLowerCase().replace(/\s+/g, "_");
      keys.push(
        `${moduleKey}_${parentKey}_view`,
        `${moduleKey}_${parentKey}_edit`,
        `${moduleKey}_${parentKey}_export`
      );

      item.subItems.forEach((sub) => {
        const subKey = sub.name.toLowerCase().replace(/\s+/g, "_");
        keys.push(`${moduleKey}_${parentKey}_${subKey}_edit`);
      });
    } else {
      const itemName = typeof item === "object" ? item.name : item;
      const itemKey = itemName.toLowerCase().replace(/\s+/g, "_");
      keys.push(
        `${moduleKey}_${itemKey}_view`,
        `${moduleKey}_${itemKey}_edit`,
        `${moduleKey}_${itemKey}_export`
      );
    }
  });

  // Module-level sub-items (e.g. Candidate Search under Locum Job)
  section.subItems?.forEach((sub) => {
    const subKey = sub.name.toLowerCase().replace(/\s+/g, "_");
    keys.push(
      `${moduleKey}_${subKey}_view`,
      `${moduleKey}_${subKey}_edit`,
      `${moduleKey}_${subKey}_export`
    );
  });

  return keys;
};
const isModuleFullyChecked = (section, action) => {
  const keys = getModulePermissionKeys(section).filter((k) =>
    k.endsWith(`_${action}`)
  );

  return keys.length > 0 && keys.every((k) => permissions[k]);
};
const handleSelectAllModule = (section, action) => {
  const keys = getModulePermissionKeys(section).filter((k) =>
    k.endsWith(`_${action}`)
  );

  const shouldCheck = !isModuleFullyChecked(section, action);

  setPermissions((prev) => {
    const updated = { ...prev };

    keys.forEach((key) => {
      updated[key] = shouldCheck;

      // Auto-enable view when edit/export selected
      if ((action === "edit" || action === "export") && shouldCheck) {
        updated[key.replace(`_${action}`, "_view")] = true;
      }

      // Auto-disable edit/export if view unchecked
      if (action === "view" && !shouldCheck) {
        updated[key.replace("_view", "_edit")] = false;
        updated[key.replace("_view", "_export")] = false;
      }
    });

    return updated;
  });
};



  //  const getData = async () => {
  //   try {
  //     const response = await getAdminUserByIdService(ID);
  //     if (response) {
  //       const userData = response[0];
  //       const transformedData = {
  //         ...userData,
  //         permissions: userData.permissions?.map(perm => ({
  //           module: perm.module,
  //           actions: Array.isArray(perm.actions) ? perm.actions : []
  //         })) || []
  //       };

  //       setResponseData(transformedData);
  //       reset(transformedData); // Reset form with the fetched data
  //       return transformedData;
  //     }
  //     return {};
  //   } catch (error) {
  //     console.error("Error fetching admin user:", error);
  //     return {};
  //   }
  // };

  const getModuleFormKey = (moduleName) => {
    const moduleToFormKeyMap = {
      jdRule: "common_job_description",
      additionaltraining: "common_additional_training",
      city: "common_cities",
      companyTypes: "common_company_type",
      departmenttype: "common_department_types",
      documenttype: "common_document_types",
      language: "common_languages",
      experience: "common_experience",
      bill: "billing_bill_of_supply",
      specialization: "common_specialization",
      professionalRegistrationTypes: "common_professional_registration_types",
      professionalregistrationtypes: "common_professional_registration_types",
      professionalTypes: "common_profession",
      qualificationTypes: "common_qualifications",
      software: "common_software",
      skillsRoute: "common_additional_skills",
      gccDepartment: "common_international_department",
      gccExperience: "common_international_experience",
      company: "hospital_corporate",
      organization: "hospital_company",
      branch: "hospital_branch",
      departments: "hospital_department",
      rate: "hospital_rates",
      application: "locum_job_application",
      job: "locum_job_locum_jobs",
      job_shiftLogs: "locum_job_shift_logs",
      candidate_search: "locum_job_candidate_search",
      permanentapplication: "permanent_job_applications",
      permanentjob: "permanent_job_job",
      credit_limit: "credit_limit_credit_limit",
      user: "users_nursehospital_user",
      verification: "users_presign_up_user",
      subscription: "users_premium_user",
      docVerification: "users_document_verification",
      orwin: "users_orwin_candidates",
      upcomingEvents: "events_events_list",
      interviewslot: "events_interview",
      refferal: "events_referral",
      invoice: "locum_invoices_professional_invoice",
      invoiceTax: "locum_invoices_professional_tax_invoice",
      bank: "locum_invoices_bank_details",
      availability: "availability_availability",
      monetization: "monetization_monetization_mlp",
      global_settings: "rewards_engine_global_settings",
      event_configuration: "rewards_engine_event_configuration",
      referral_levels: "rewards_engine_referral_levels",
      analytics: "rewards_engine_analytics",
    };

    return moduleToFormKeyMap[moduleName] || moduleName;
  };
  const [originalPassword, setOriginalPassword] = useState("");

  useEffect(() => {
    const fetchData = async () => {
      try {
        console.log("📡 Fetching Admin User details for ID:", ID);
        const response = await getAdminUserByIdService(ID);

        console.log("✅ Full API Response:", response);

        if (response && response.length > 0) {
          const userData = response[0];
          setOriginalPassword(userData.password || "");
          console.log("🧩 Extracted User Data:", userData);
          const { password, ...userDataWithoutPassword } = userData;
          const resetData = password
            ? userData
            : { ...userDataWithoutPassword, password: "" };

          setResponseData(userData);
          reset(resetData);

          // Convert API permissions array into checkbox state object
          const permissionsMap = {};
          userData.permissions?.forEach((perm) => {
            const { module, actions } = perm;
            console.log("Module?????", module);
            console.log("Actions:", actions);

            // Special handling for invoice approvals
            if (module === "invoice") {
              if (actions.includes("financeApprove")) {
                permissionsMap[
                  "locum_invoices_professional_invoice_finance_approval_edit"
                ] = true;
              }
              if (actions.includes("operationApprove")) {
                permissionsMap[
                  "locum_invoices_professional_invoice_ops_approval_edit"
                ] = true;
              }
            }

            // Map each action to the correct form key
            actions.forEach((act) => {
              if (act === "financeApprove" || act === "operationApprove") {
                // Already handled above
                return;
              }

              const formKey = getModuleFormKey(module);
              if (formKey) {
                const key = `${formKey
                  .toLowerCase()
                  .replace(/\s+/g, "_")}_${act}`;
                permissionsMap[key] = true;

                // Auto-check view if edit/export is checked
                if (
                  (act === "edit" || act === "export") &&
                  !permissionsMap[`${formKey}_view`]
                ) {
                  permissionsMap[`${formKey}_view`] = true;
                }
              }
            });
          });

          console.log("✅ Mapped Permissions:", permissionsMap);
          setPermissions(permissionsMap);
        }
      } catch (error) {
        console.error("❌ Error fetching admin user:", error);
      }
    };

    fetchData();
  }, [ID]);

  const {
    register,
    setValue,
    handleSubmit,
    getValues,
    control,
    watch,
    reset,
    formState: { errors },
  } = useForm({
    // defaultValues: () => getData(),
    resolver: yupResolver(adminUserFormValidation),
  });
  const navigate = useNavigate();
  const dispatch = useDispatch();
  // const onSubmit = (data) => {

  //   let payload = {
  //     name: {
  //       first: data?.name?.first,
  //       last: data?.name?.last,
  //     },

  //     isDeleted: data?.isDeleted,
  //     role: data?.role,
  //     password: data?.password,
  //     email: data?.email,
  //     isAdmin: data?.isAdmin,
  //     // createdAt: data?.createdAt,
  //     // updatedAt: data?.updatedAt,
  //   };

  //   dispatch(updateAdminUSer({ payload: payload, id: ID })).then(() => {
  //     navigate("/dashboards/admin");
  //   });
  // };

  const getModulePayloadName = (moduleId) => {
    if (!moduleId) return moduleId;

    // Normalize and clean
    let cleaned = moduleId.toLowerCase().trim();

    // Remove prefixes (common_, billing_, etc.)
    cleaned = cleaned
      .replace(/^common_/, "")
      .replace(/^events_/, "")
      .replace(/^hospital_/, "")
      .replace(/^LocumJob_/, "")
      .replace(/^permanentJob_/, "")
      .replace(/^creditLimit_/, "")
      .replace(/^users_/, "")
      .replace(/^billing_/, "")
      .replace(/^locum_invoices_/, "")
      .replace(/^availability_/, "")
      .replace(/^monetization_/, "")
      .replace(/^rewards_engine_/, "")
      .replace(/_(view|edit|export)$/, ""); // remove action suffix if any

    // Extra normalization: remove duplicate underscores and spaces
    cleaned = cleaned.replace(/\s+/g, "_").replace(/_+/g, "_");

    // Fuzzy map
    const moduleMap = {
      // Common modules
      jobdescription: "jdRule",
      job_description: "jdRule",
      jd_rule: "jdRule",

      

      additionaltraining: "additionaltraining",
      additional_training: "additionaltraining",

      cities: "city",
      city: "city",

      companytype: "companyTypes",
      company_type: "companyTypes",

      departmenttype: "departmenttype",
      departmenttypes: "departmenttype",
      department_types: "departmenttype",

      documenttype: "documenttype",
      documenttypes: "documenttype",
      document_types: "documenttype",

      languages: "language",
      experience: "experience",
      specialization: "specialization",

      professionalregistrationtypes: "professionalregistrationtypes",
      professional_registration_types: "professionalregistrationtypes",
      professionalregistrationtype: "professionalregistrationtypes",
      common_professional_registration_types: "professionalRegistrationTypes",
      common_professional_registration_types: "professionalregistrationtypes",
      

      profession: "professionalTypes",
      qualifications: "qualificationTypes",
      software: "software",
      subscription: "subscription",
      additionalskills: "skillsRoute",

      gccdepartment: "gccDepartment",
      gcc_department: "gccDepartment",
      internationaldepartment: "gccDepartment",
      international_department: "gccDepartment",
      common_international_department: "gccDepartment",
      commoninternationaldepartment: "gccDepartment",
      gccdepartment: "gccDepartment",
      internationaldepartment: "gccDepartment",

      gccexperience: "gccExperience",
      gcc_experience: "gccExperience",
      internationalexperience: "gccExperience",
      international_experience: "gccExperience",

      // Hospital modules
      corporate: "company",
      company: "organization",
      branch: "branch",
      department: "departments",
      rates: "rate",

      // Locum Job modules
      application: "application",
      locum_jobs: "job",
      locum_jobs_shift_logs: "job_shiftLogs",
      locum_jobs_shiftlogs: "job_shiftLogs",
      locum_job_shift_logs: "job_shiftLogs",
      locum_job_shiftlogs: "job_shiftLogs",

      shift_logs: "job_shiftLogs",
      shiftlogs: "job_shiftLogs",

      // Permanent Job modules
      permanent_job_applications: "permanentapplication",
      permanentjob_applications: "permanentapplication",
      applications: "permanentapplication",
      permanentapplication: "permanentapplication",
      applications: "permanentapplication",
      permanentapplication: "permanentapplication",
      job: "permanentjob",
      credit_limit: "credit_limit",

      //` Users modules
      nursehospital_user: "user",
      presign_up_user: "verification",
      premiumUser: "subscription",
      premium_user: "subscription",
      document_verification: "docVerification",
      orwin_candidates: "orwin",

      // Events modules
      events: "upcomingEvents",
      interview: "interviewslot",
      referral: "refferal",

      // Other modules
      bill_of_supply: "bill",
      professional_invoice: "invoice",
      professional_tax_invoice: "invoiceTax",
      finance_approval: "finance_approval",
      ops_approval: "ops_approval",
      bank_details: "bank_details",
      availability: "availability",
      monetization_mlp: "monetization",
      global_settings: "global_settings",
      event_configuration: "event_configuration",
      referral_levels: "referral_levels",
      analytics: "analytics",
    };

    // 1️⃣ Try exact match
    if (moduleMap[cleaned]) return moduleMap[cleaned];

    // 2️⃣ Try relaxed matching — remove underscores and match base
    const base = cleaned.replace(/_/g, "");
    for (const [key, value] of Object.entries(moduleMap)) {
      const normalizedKey = key.replace(/_/g, "");
      if (base.includes(normalizedKey)) {
        return value;
      }
    }

    // 3️⃣ Log if still not matched
    console.warn(
      `⚠️ No mapping found for module: "${moduleId}" (cleaned: "${cleaned}")`
    );
    return moduleId;
  };

  
  const onSubmit = (data) => {
    const transformedPermissions = [];
    const moduleActionMap = new Map();

    // First pass: collect all actions for each module
    Object.entries(permissions).forEach(([key, value]) => {
      if (!value) return;

      const parts = key.split("_");
      const action = parts.pop();
      const modulePath = parts.join("_");

      console.log(
        `Processing permission: ${key}, action: ${action}, modulePath: ${modulePath}`
      );

      // Special handling for finance/ops approval
      // if (
      //   modulePath.includes(
      //     "locum_invoices_professional_invoice_finance_approval"
      //   ) ||
      //   modulePath.includes("locum_invoices_professional_invoice_ops_approval")
      // ) {
      //   const payloadModule = "invoice";
      //   if (!moduleActionMap.has(payloadModule)) {
      //     moduleActionMap.set(payloadModule, new Set(["view", "export"]));
      //   }

      //   const actions = moduleActionMap.get(payloadModule);
      //   if (
      //     modulePath.includes("finance_approval") &&
      //     !actions.has("financeApprove")
      //   ) {
      //     actions.add("financeApprove");
      //   }
      //   if (
      //     modulePath.includes("ops_approval") &&
      //     !actions.has("operationApprove")
      //   ) {
      //     actions.add("operationApprove");
      //   }
      //   return;
      // }

      // In your permission processing loop, update the invoice approval handling:
if (modulePath.includes("locum_invoices_professional_invoice_finance_approval") ||
    modulePath.includes("locum_invoices_professional_invoice_ops_approval")) {
  const payloadModule = "invoice";
  if (!moduleActionMap.has(payloadModule)) {
    // Only include view by default, not export
    moduleActionMap.set(payloadModule, new Set(["view"]));
  }

  const actions = moduleActionMap.get(payloadModule);
  if (modulePath.includes("finance_approval") && !actions.has("financeApprove")) {
    actions.add("financeApprove");
  }
  if (modulePath.includes("ops_approval") && !actions.has("operationApprove")) {
    actions.add("operationApprove");
  }
  return;
}

// Then add a separate handler for the base invoice view
if (modulePath === "locum_invoices_professional_invoice") {
  const payloadModule = "invoice";
  if (!moduleActionMap.has(payloadModule)) {
    moduleActionMap.set(payloadModule, new Set());
  }
  moduleActionMap.get(payloadModule).add(action); // This will only add the action that was explicitly checked
  return;
}
      // Special handling for professional tax invoice
      if (modulePath.includes("professional_tax_invoice")) {
        const payloadModule = "invoiceTax";
        if (!moduleActionMap.has(payloadModule)) {
          moduleActionMap.set(payloadModule, new Set());
        }
        moduleActionMap.get(payloadModule).add(action);
        return;
      }

      // Special handling for document types
      if (
        modulePath.includes("document_types") ||
        modulePath.includes("document types")
      ) {
        const payloadModule = "documenttype";
        if (!moduleActionMap.has(payloadModule)) {
          moduleActionMap.set(payloadModule, new Set());
        }
        moduleActionMap.get(payloadModule).add(action);
        return;
      }
// Add this special case for document verification
if (modulePath.includes('document_verification') || 
    modulePath.includes('documentverification') ||
    modulePath.includes('doc_verification')||
   modulePath === 'users_document_verification') {
  const payloadModule = 'docVerification';
  if (!moduleActionMap.has(payloadModule)) {
    moduleActionMap.set(payloadModule, new Set());
  }
  moduleActionMap.get(payloadModule).add(action);
  return;
}
      // In your permission processing loop, add this special case
if (modulePath.includes('professional_registration') || 
    modulePath.includes('professionalregistration')) {
  const payloadModule = 'professionalRegistrationTypes';
  if (!moduleActionMap.has(payloadModule)) {
    moduleActionMap.set(payloadModule, new Set());
  }
  moduleActionMap.get(payloadModule).add(action);
  return;
}
      // Special handling for bank details
      if (modulePath.includes("bank") || modulePath.includes("details")) {
        const payloadModule = "bank";
        if (!moduleActionMap.has(payloadModule)) {
          moduleActionMap.set(payloadModule, new Set());
        }
        moduleActionMap.get(payloadModule).add(action);
        return;
      }

      // Special handling for department types
      if (
        modulePath.includes("department_types") ||
        modulePath.includes("departmenttypes") ||
        modulePath.includes("department types")
      ) {
        const payloadModule = "departmenttype";
        if (!moduleActionMap.has(payloadModule)) {
          moduleActionMap.set(payloadModule, new Set());
        }
        moduleActionMap.get(payloadModule).add(action);
        return;
      }
      // Add this special case in your permission processing loop
if (modulePath.includes('common_international_department') || 
    modulePath.includes('common_gcc_department') ||
    modulePath.includes('gcc_department') ||
    modulePath.includes('international_department')) {
  const payloadModule = 'gccDepartment';
  if (!moduleActionMap.has(payloadModule)) {
    moduleActionMap.set(payloadModule, new Set());
  }
  moduleActionMap.get(payloadModule).add(action);
  return;
}

      // Special handling for candidate search (sub-item under Locum Job)
      if (modulePath.includes("candidate_search")) {
        const payloadModule = "candidate_search";
        if (!moduleActionMap.has(payloadModule)) {
          moduleActionMap.set(payloadModule, new Set());
        }
        moduleActionMap.get(payloadModule).add(action);
        return;
      }

      // For other modules, try to map them
      const moduleKey = getModulePayloadName(modulePath);

      if (!moduleActionMap.has(moduleKey)) {
        moduleActionMap.set(moduleKey, new Set());
      }

      // Add the action to the module's action set
      moduleActionMap.get(moduleKey).add(action);
    });

    // Convert the map to the final permissions array
    moduleActionMap.forEach((actions, module) => {
      if (actions.size > 0) {
        // Only include modules with actions
        transformedPermissions.push({
          module,
          actions: Array.from(actions).sort(),
        });
      }
    });

    console.log("Processed permissions:", transformedPermissions);

    const payload = {
      name: {
        first: data?.name?.first,
        last: data?.name?.last,
      },

      isDeleted: data?.isDeleted,
      accountDisable: data?.accountDisable=== 'true' ? true : false,
      // role: data?.role,
     
      email: data?.email,
      permissions: transformedPermissions,
      // isAdmin: data?.isAdmin,
      
      isSuperAdmin: data?.isSuperAdmin === 'true' ? true : false,
      // createdAt: data?.createdAt,
      // updatedAt: data?.updatedAt,
    };
    if(data?.password!==""){
      payload.password= data?.password;
     }



    console.log("✅ Final Payload to submit:", payload);

    dispatch(updateAdminUSer({ payload: payload, id: ID })).then(() => {
      navigate("/dashboards/admin");
    });
  };
  const handleReset = () => {
    reset();
  };

  const formValues = getValues();

  const handleBack = () => {
    navigate(-1);
  };
  const [created1, setCreated1] = useState(false);
  const [updated1, setUpdated1] = useState(false);
  const [passwordField, setpasswordField] = useState(false);
  useEffect(() => {
    const created = getValues("createdAt");
    const updated = getValues("updatedAt");
    const password = getValues("password");

    if (created == "Invalid date") {
      setValue("createdAt", "");
    }
    if (updated == "Invalid date") {
      setValue("updatedAt", "");
    }

    if (created != undefined && created != "") {
      if (!created1) {
        setValue("createdAt", Moment(created).format("DD/MM/YYYY"));
      }
      setCreated1(true);
    }

    if (updated !== undefined && updated != "") {
      if (!updated1) {
        setValue("updatedAt", Moment(updated).format("DD/MM/YYYY"));
      }
      setUpdated1(true);
    }
    if(password!=undefined)
    {
      if(!passwordField)
      {
        setValue("password","");
      }
      setpasswordField(true)
    }
  }, [getValues("createdAt"), getValues("updatedAt"), getValues("password")]);

  const [permissions, setPermissions] = useState([]);

  const handlePermissionChange = (key) => {
    setPermissions((prev) => {
      const updated = { ...prev };
      const parts = key.split("_");
      const action = parts.pop(); // view, edit, export
      const baseKey = parts.join("_");
      const isChecked = !updated[key];

      updated[key] = isChecked;

      // Auto-check "view" when edit/export selected
      if ((action === "edit" || action === "export") && isChecked) {
        updated[`${baseKey}_view`] = true;
      }

      // Auto-uncheck edit/export when view unchecked
      if (action === "view" && !isChecked) {
        updated[`${baseKey}_edit`] = false;
        updated[`${baseKey}_export`] = false;
      // Uncheck approval checkboxes when view unchecked
      if (baseKey.includes("professional_invoice")) {
        updated[`${baseKey}_ops_approval_edit`] = false;
        updated[`${baseKey}_finance_approval_edit`] = false;
      }
    }

    // ✅ Uncheck only submodules when edit is unchecked (not view)
    if (action === "edit" && !isChecked) {
      Object.keys(updated).forEach((k) => {
        if (
          k.startsWith(baseKey) &&
          k !== key &&
          (k.includes("ops_approval") || k.includes("finance_approval"))
        ) {
          updated[k] = false;
        }
      });
    }

    // ✅ Auto-check Professional Invoice Edit when Ops or Finance Approval toggled
    if (key.includes("ops_approval_edit") || key.includes("finance_approval_edit")) {
      const parentEditKey = baseKey.replace(/_(ops|finance)_approval$/, "");
      updated[`${parentEditKey}_edit`] = true;
      updated[`${parentEditKey}_view`] = true; // ensure view also checked
    }

      return updated;
    });
  };

  const permissionsData = [
    {
      module: "Common",
      items: [
        "Job Description",
        "Additional Training",
        "Cities",
        "Company Type",
        "Department Types",
        "Document Types",
        "Languages",
        "Experience",
        "Specialization",
        "Professional Registration Types",
        "Profession",
        "Qualifications",
        "Software",
        "Additional skills",
        "International Department",
        "International Experience",
      ],
    },
    {
      module: "Events",
      items: ["Events List", "Interview", "Referral"],
    },
    {
      module: "Hospital",
      items: ["Corporate", "Company", "Branch", "Department", "Rates"],
    },
    {
      module: "Locum Job",
      items: [
        "Application",
        "Locum Jobs",
        { name: "Candidate Search", isSubItem: true },
        "Shift Logs",
      ],
    },
    {
      module: "Permanent Job",
      items: ["Applications", "Job"],
    },
    {
      module: "Credit Limit",
      items: ["Credit Limit"],
    },
    {
      module: "Users",
      items: [
        "NurseHospital User",
        "PreSign Up User",
        "Premium User",
        "Document Verification",
        "Orwin Candidates",
      ],
    },
    {
      module: "Billing",
      items: ["Bill of Supply"],
    },
    {
      module: "Locum Invoices",
      items: [
        {
          name: "Professional Invoice",
          subItems: [
            { name: "Finance Approval", type: "approval" },
            { name: "Ops Approval", type: "approval" },
          ],
        },
        "Professional Tax Invoice",
        "Bank Details",
      ],
    },
    {
      module: "Availability",
      items: ["Availability"],
    },
    {
      module: "Rewards Engine",
      items: ["Global Settings", "Event Configuration", "Referral Levels", "Analytics"],
    },
    {
      module: "Monetization",
      items: ["Monetization MLP"],
    },
  ];
  //  const renderPermissionsTable = (permissions) => {
  // const renderPermissionsTable = () => {
  //   const currentPermissions = permissions; // use the state directly

  //   // if (!permissions || permissions.length === 0) {
  //   //   return <Typography variant="body2">No permissions assigned</Typography>;
  //   // }
  //   // if (!currentPermissions || Object.keys(currentPermissions).length === 0) {
  //   //   return <Typography variant="body2">No permissions assigned</Typography>;
  //   // }

  //   // Get unique modules from permissions
  //   // const modules = [...new Set(permissions.map(p => p.module))];

  //   return (
  //     <div>
  //       <div className="permissions-header">
  //         <h3 className="permissions-title">Module Permissions</h3>
  //         <p className="permissions-hint">
  //           Checking Edit or Export will auto-check View
  //         </p>
  //       </div>

  //       <div className="permissions-table-wrapper">
  //         <table className="permissions-table">
  //           <thead>
  //             <tr className="permissions-table-header">
  //               <th>Module</th>
  //               <th>Item</th>
  //               <th>View</th>
  //               <th>Edit</th>
  //               <th>Export</th>
  //             </tr>
  //           </thead>
  //           <tbody>
  //             {permissionsData.map((section) => {
  //               let rowCount = 0;
  //               section.items.forEach((item) => {
  //                 if (typeof item === "object" && item.subItems) {
  //                   rowCount += 1 + item.subItems.length;
  //                 } else {
  //                   rowCount += 1;
  //                 }
  //               });

  //               return (
  //                 <React.Fragment key={section.module}>
  //                   {section.items.map((item, index) => {
  //                     const moduleKey = section.module
  //                       .toLowerCase()
  //                       .replace(/\s+/g, "_");

  //                     // Handle nested items (objects with subItems)
  //                     if (typeof item === "object" && item.subItems) {
  //                       const parentItemKey = item.name
  //                         .toLowerCase()
  //                         .replace(/\s+/g, "_");
  //                       return (
  //                         <React.Fragment
  //                           key={`${section.module}-${item.name}`}
  //                         >
  //                           {/* Parent item row */}
  //                           <tr className="permissions-table-row parent-item-row">
  //                             {index === 0 && (
  //                               <td
  //                                 rowSpan={rowCount}
  //                                 className="permissions-module-cell"
  //                               >
  //                                 {section.module}
  //                               </td>
  //                             )}
  //                             <td className="permissions-item-cell parent-item">
  //                               {item.name}
  //                             </td>
  //                             <td className="permissions-checkbox-cell">
  //                               <input
  //                                 type="checkbox"
  //                                 className="permissions-checkbox"
  //                                 checked={
  //                                   permissions[
  //                                     `${moduleKey}_${parentItemKey}_view`
  //                                   ] || false
  //                                 }
  //                                 onChange={() =>
  //                                   handlePermissionChange(
  //                                     `${moduleKey}_${parentItemKey}_view`
  //                                   )
  //                                 }
  //                               />
  //                             </td>
  //                             <td className="permissions-checkbox-cell">
  //                               <input
  //                                 type="checkbox"
  //                                 className="permissions-checkbox"
  //                                 checked={
  //                                   permissions[
  //                                     `${moduleKey}_${parentItemKey}_edit`
  //                                   ] || false
  //                                 }
  //                                 onChange={() =>
  //                                   handlePermissionChange(
  //                                     `${moduleKey}_${parentItemKey}_edit`
  //                                   )
  //                                 }
  //                               />
  //                             </td>
  //                             <td className="permissions-checkbox-cell">
  //                               <input
  //                                 type="checkbox"
  //                                 className="permissions-checkbox"
  //                                 checked={
  //                                   permissions[
  //                                     `${moduleKey}_${parentItemKey}_export`
  //                                   ] || false
  //                                 }
  //                                 onChange={() =>
  //                                   handlePermissionChange(
  //                                     `${moduleKey}_${parentItemKey}_export`
  //                                   )
  //                                 }
  //                               />
  //                             </td>
  //                           </tr>

  //                           {/* Sub-items rows */}
  //                           {item.subItems.map((subItem) => {
  //                             const subItemName =
  //                               typeof subItem === "string"
  //                                 ? subItem
  //                                 : subItem.name;
  //                             const subItemType =
  //                               typeof subItem === "string"
  //                                 ? "normal"
  //                                 : subItem.type;
  //                             const subItemKey = subItem.name
  //                               .toLowerCase()
  //                               .replace(/\s+/g, "_");
  //                             const fullItemKey = `${parentItemKey}_${subItemKey}`;
  //                             const permissionsBaseKey = `${moduleKey}_${fullItemKey}`;
  //                             if (subItemType === "approval") {
  //                               // Only one checkbox (acts like edit)
  //                               return (
  //                                 <tr
  //                                   key={`${section.module}-${item.name}-${subItem.name}`}
  //                                   className="permissions-table-row sub-item-row"
  //                                 >
  //                                   <td className="permissions-item-cell sub-item">
  //                                     — {subItem.name}
  //                                   </td>

  //                                   {/* View column - empty */}
  //                                   <td className="permissions-checkbox-cell text-center"></td>

  //                                   {/* Edit column - show checkbox centered */}
  //                                   <td className="permissions-checkbox-cell text-center">
  //                                     <input
  //                                       type="checkbox"
  //                                       className="permissions-checkbox"
  //                                       checked={
  //                                         permissions[
  //                                           `${permissionsBaseKey}_edit`
  //                                         ] || false
  //                                       }
  //                                       onChange={() =>
  //                                         handlePermissionChange(
  //                                           `${permissionsBaseKey}_edit`
  //                                         )
  //                                       }
  //                                     />
  //                                   </td>

  //                                   {/* Export column - empty */}
  //                                   <td className="permissions-checkbox-cell text-center"></td>
  //                                 </tr>
  //                               );
  //                             }
  //                             return (
  //                               <tr
  //                                 key={`${section.module}-${item.name}-${subItem}`}
  //                                 className="permissions-table-row sub-item-row"
  //                               >
  //                                 <td className="permissions-item-cell sub-item">
  //                                   — {subItem}
  //                                 </td>
  //                                 <td className="permissions-checkbox-cell">
  //                                   <input
  //                                     type="checkbox"
  //                                     className="permissions-checkbox"
  //                                     checked={
  //                                       permissions[
  //                                         `${moduleKey}_${fullItemKey}_view`
  //                                       ] || false
  //                                     }
  //                                     onChange={() =>
  //                                       handlePermissionChange(
  //                                         `${moduleKey}_${fullItemKey}_view`
  //                                       )
  //                                     }
  //                                   />
  //                                 </td>
  //                                 <td className="permissions-checkbox-cell">
  //                                   <input
  //                                     type="checkbox"
  //                                     className="permissions-checkbox"
  //                                     checked={
  //                                       permissions[
  //                                         `${moduleKey}_${fullItemKey}_edit`
  //                                       ] || false
  //                                     }
  //                                     onChange={() =>
  //                                       handlePermissionChange(
  //                                         `${moduleKey}_${fullItemKey}_edit`
  //                                       )
  //                                     }
  //                                   />
  //                                 </td>
  //                                 <td className="permissions-checkbox-cell">
  //                                   <input
  //                                     type="checkbox"
  //                                     className="permissions-checkbox"
  //                                     checked={
  //                                       permissions[
  //                                         `${moduleKey}_${fullItemKey}_export`
  //                                       ] || false
  //                                     }
  //                                     onChange={() =>
  //                                       handlePermissionChange(
  //                                         `${moduleKey}_${fullItemKey}_export`
  //                                       )
  //                                     }
  //                                   />
  //                                 </td>
  //                               </tr>
  //                             );
  //                           })}
  //                         </React.Fragment>
  //                       );
  //                     }

  //                     // Regular items (string)
  //                     const itemKey = item.toLowerCase().replace(/\s+/g, "_");
  //                     const viewKey = `${moduleKey}_${itemKey}_view`;
  //                     const editKey = `${moduleKey}_${itemKey}_edit`;
  //                     const exportKey = `${moduleKey}_${itemKey}_export`;

  //                     return (
  //                       <tr
  //                         key={`${section.module}-${item}`}
  //                         className="permissions-table-row"
  //                       >
  //                         {index === 0 && (
  //                           <td
  //                             rowSpan={rowCount}
  //                             className="permissions-module-cell"
  //                           >
  //                             {section.module}
  //                           </td>
  //                         )}
  //                         <td className="permissions-item-cell">{item}</td>
  //                         <td className="permissions-checkbox-cell">
  //                           <input
  //                             type="checkbox"
  //                             className="permissions-checkbox"
  //                             checked={currentPermissions[viewKey] || false}
  //                             onChange={() => handlePermissionChange(viewKey)}
  //                           />
  //                         </td>
  //                         <td className="permissions-checkbox-cell">
  //                           <input
  //                             type="checkbox"
  //                             className="permissions-checkbox"
  //                             checked={permissions[editKey] || false}
  //                             onChange={() => handlePermissionChange(editKey)}
  //                           />
  //                         </td>
  //                         <td className="permissions-checkbox-cell">
  //                           <input
  //                             type="checkbox"
  //                             className="permissions-checkbox"
  //                             checked={permissions[exportKey] || false}
  //                             onChange={() => handlePermissionChange(exportKey)}
  //                           />
  //                         </td>
  //                       </tr>
  //                     );
  //                   })}
  //                 </React.Fragment>
  //               );
  //             })}
  //           </tbody>
  //         </table>
  //       </div>
  //     </div>
  //   );
  // };

  const renderPermissionsTable = () => {
    return (
      <div className="permissions-table-wrapper">
        <table className="permissions-table">
          <thead>
            <tr>
              <th colSpan={2}>Module</th>
              <th>View</th>
              <th>Edit</th>
              <th>Export</th>
            </tr>
          </thead>
  
          <tbody>
            {permissionsData.map((section) => {
              const isExpanded = expandedModules[section.module];
              const moduleKey = section.module
                .toLowerCase()
                .replace(/\s+/g, "_");
  
              return (
                <React.Fragment key={section.module}>
                  {/* 🔹 MODULE HEADER */}
                  <tr className="permissions-module-header">
                    <td colSpan={2}>
                      <div
                        className="module-title"
                        onClick={() => toggleModule(section.module)}
                      >
                        {section.module}
                        <span className="dropdown-icon">
                          {isExpanded ? "▼" : "▶"}
                        </span>
                      </div>
                    </td>
  
                    {/* SHOW SELECT ALL ONLY WHEN EXPANDED */}
                    {isExpanded ? (
                      <>
                        <td>
                          <input
                            type="checkbox"
                            checked={isModuleFullyChecked(section, "view")}
                            onChange={() =>
                              handleSelectAllModule(section, "view")
                            }
                          />
                        </td>
                        <td>
                          <input
                            type="checkbox"
                            checked={isModuleFullyChecked(section, "edit")}
                            onChange={() =>
                              handleSelectAllModule(section, "edit")
                            }
                          />
                        </td>
                        <td>
                          <input
                            type="checkbox"
                            checked={isModuleFullyChecked(section, "export")}
                            onChange={() =>
                              handleSelectAllModule(section, "export")
                            }
                          />
                        </td>
                      </>
                    ) : (
                      <td colSpan={3}></td>
                    )}
                  </tr>
  
                  {/* 🔹 MODULE ITEMS (ONLY IF EXPANDED) */}
                  {isExpanded &&
                    section.items.map((item) => {
                      // ---------- SIMPLE ITEM ----------
                      if (typeof item === "string") {
                        const itemKey = item
                          .toLowerCase()
                          .replace(/\s+/g, "_");
  
                        return (
                          <tr key={`${section.module}-${item}`}>
                            <td></td>
                            <td>{item}</td>
  
                            <td>
                              <input
                                type="checkbox"
                                checked={
                                  permissions[`${moduleKey}_${itemKey}_view`] ||
                                  false
                                }
                                onChange={() =>
                                  handlePermissionChange(
                                    `${moduleKey}_${itemKey}_view`
                                  )
                                }
                              />
                            </td>
                            <td>
                              <input
                                type="checkbox"
                                checked={
                                  permissions[`${moduleKey}_${itemKey}_edit`] ||
                                  false
                                }
                                onChange={() =>
                                  handlePermissionChange(
                                    `${moduleKey}_${itemKey}_edit`
                                  )
                                }
                              />
                            </td>
                            <td>
                              <input
                                type="checkbox"
                                checked={
                                  permissions[
                                    `${moduleKey}_${itemKey}_export`
                                  ] || false
                                }
                                onChange={() =>
                                  handlePermissionChange(
                                    `${moduleKey}_${itemKey}_export`
                                  )
                                }
                              />
                            </td>
                          </tr>
                        );
                      }
  
                      // ---------- STANDALONE SUB-ITEM (e.g. Candidate Search) ----------
                      if (item.isSubItem) {
                        const subItemKey = item.name
                          .toLowerCase()
                          .replace(/\s+/g, "_");

                        return (
                          <tr key={`${section.module}-${item.name}`}>
                            <td></td>
                            <td>— {item.name}</td>
                            <td>
                              <input
                                type="checkbox"
                                checked={
                                  permissions[
                                    `${moduleKey}_${subItemKey}_view`
                                  ] || false
                                }
                                onChange={() =>
                                  handlePermissionChange(
                                    `${moduleKey}_${subItemKey}_view`
                                  )
                                }
                              />
                            </td>
                            <td>
                              <input
                                type="checkbox"
                                checked={
                                  permissions[
                                    `${moduleKey}_${subItemKey}_edit`
                                  ] || false
                                }
                                onChange={() =>
                                  handlePermissionChange(
                                    `${moduleKey}_${subItemKey}_edit`
                                  )
                                }
                              />
                            </td>
                            <td>
                              <input
                                type="checkbox"
                                checked={
                                  permissions[
                                    `${moduleKey}_${subItemKey}_export`
                                  ] || false
                                }
                                onChange={() =>
                                  handlePermissionChange(
                                    `${moduleKey}_${subItemKey}_export`
                                  )
                                }
                              />
                            </td>
                          </tr>
                        );
                      }

                      // ---------- NESTED ITEM ----------
                      const parentKey = item.name
                        .toLowerCase()
                        .replace(/\s+/g, "_");
  
                      return (
                        <React.Fragment key={item.name}>
                          {/* Parent */}
                          <tr className="parent-item-row">
                            <td></td>
                            <td>{item.name}</td>
  
                            <td>
                              <input
                                type="checkbox"
                                checked={
                                  permissions[
                                    `${moduleKey}_${parentKey}_view`
                                  ] || false
                                }
                                onChange={() =>
                                  handlePermissionChange(
                                    `${moduleKey}_${parentKey}_view`
                                  )
                                }
                              />
                            </td>
                            <td>
                              <input
                                type="checkbox"
                                checked={
                                  permissions[
                                    `${moduleKey}_${parentKey}_edit`
                                  ] || false
                                }
                                onChange={() =>
                                  handlePermissionChange(
                                    `${moduleKey}_${parentKey}_edit`
                                  )
                                }
                              />
                            </td>
                            <td>
                              <input
                                type="checkbox"
                                checked={
                                  permissions[
                                    `${moduleKey}_${parentKey}_export`
                                  ] || false
                                }
                                onChange={() =>
                                  handlePermissionChange(
                                    `${moduleKey}_${parentKey}_export`
                                  )
                                }
                              />
                            </td>
                          </tr>
  
                          {/* Sub Items */}
                          {item.subItems.map((sub) => {
                            const subKey = sub.name
                              .toLowerCase()
                              .replace(/\s+/g, "_");
  
                            return (
                              <tr key={sub.name}>
                                <td></td>
                                <td>— {sub.name}</td>
                                <td></td>
                                <td>
                                  <input
                                    type="checkbox"
                                    checked={
                                      permissions[
                                        `${moduleKey}_${parentKey}_${subKey}_edit`
                                      ] || false
                                    }
                                    onChange={() =>
                                      handlePermissionChange(
                                        `${moduleKey}_${parentKey}_${subKey}_edit`
                                      )
                                    }
                                  />
                                </td>
                                <td></td>
                              </tr>
                            );
                          })}
                        </React.Fragment>
                      );
                    })}

                  {/* 🔹 MODULE-LEVEL SUB ITEMS (e.g. Candidate Search) */}
                  {isExpanded &&
                    section.subItems?.map((sub) => {
                      const subKey = sub.name
                        .toLowerCase()
                        .replace(/\s+/g, "_");

                      return (
                        <tr key={`${section.module}-${sub.name}`}>
                          <td></td>
                          <td>— {sub.name}</td>

                          <td>
                            <input
                              type="checkbox"
                              checked={
                                permissions[
                                  `${moduleKey}_${subKey}_view`
                                ] || false
                              }
                              onChange={() =>
                                handlePermissionChange(
                                  `${moduleKey}_${subKey}_view`
                                )
                              }
                            />
                          </td>
                          <td>
                            <input
                              type="checkbox"
                              checked={
                                permissions[
                                  `${moduleKey}_${subKey}_edit`
                                ] || false
                              }
                              onChange={() =>
                                handlePermissionChange(
                                  `${moduleKey}_${subKey}_edit`
                                )
                              }
                            />
                          </td>
                          <td>
                            <input
                              type="checkbox"
                              checked={
                                permissions[
                                  `${moduleKey}_${subKey}_export`
                                ] || false
                              }
                              onChange={() =>
                                handlePermissionChange(
                                  `${moduleKey}_${subKey}_export`
                                )
                              }
                            />
                          </td>
                        </tr>
                      );
                    })}
                </React.Fragment>
              );
            })}
          </tbody>
        </table>
      </div>
    );
  };
  

  return (
    <>
      <DashboardLayout>
        <DashboardNavbar />
        {formValues._id ? (
          <MDBox m={2}>
            <Grid item xs={12}>
              <div style={{ display: "flex", width: "70px" }}>
                <Link onClick={handleBack}>
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      cursor: "pointer",
                    }}
                  >
                    <ArrowBackIos fontSize="small" />
                    back
                  </div>
                </Link>
              </div>
            </Grid>
            {/* <Divider /> */}
            <DialogContent>
              <form onSubmit={handleSubmit(onSubmit)}>
                <Grid container spacing={3}>
                  {/* Name Title */}
                  <Grid item xs={12}>
                    <Typography variant="h4">{params.userName}</Typography>
                  </Grid>

                  {/* Name */}
                  <Grid item xs={4}>
                    <Typography
                      variant="subtitle1"
                      sx={{ width: "80%", marginTop: "0.8rem" }}
                    >
                      Name
                    </Typography>
                  </Grid>

                  <Grid item xs={4}>
                    <MDInput
                      onKeyDown={(e) => {
                        e.key === "Enter" && e.preventDefault();
                      }}
                      placeholder="First Name"
                      sx={{ width: "100%", marginTop: "0.4rem" }}
                      inputProps={{
                        style: { fontSize: 15, fontWeight: "bold" },
                      }}
                      {...register("name.first")}
                    />
                  </Grid>
                  <Grid item xs={4}>
                    <MDInput
                      onKeyDown={(e) => {
                        e.key === "Enter" && e.preventDefault();
                      }}
                      placeholder="Last Name"
                      sx={{ width: "100%", marginTop: "0.4rem" }}
                      inputProps={{
                        style: { fontSize: 15, fontWeight: "bold" },
                      }}
                      {...register("name.last")}
                    />
                  </Grid>

                  {/* Email */}

                  <Grid item xs={4}>
                    <Typography
                      variant="subtitle1"
                      sx={{ width: "80%", marginTop: "0.8rem" }}
                    >
                      Email
                    </Typography>
                  </Grid>
                  <Grid item xs={8}>
                    <MDInput
                      onKeyDown={(e) => {
                        e.key === "Enter" && e.preventDefault();
                      }}
                      placeholder="Email"
                      sx={{ width: "100%", marginTop: "0.4rem" }}
                      inputProps={{
                        style: { fontSize: 15, fontWeight: "bold" },
                      }}
                      {...register("email")}
                      error={errors?.email?.message}
                      helperText={errors?.email?.message}
                    />
                  </Grid>

                  {/* Password */}
                  <Grid item xs={4}>
                    <Typography
                      variant="subtitle1"
                      sx={{ width: "80%", marginTop: "0.8rem" }}
                    >
                      Password
                    </Typography>
                  </Grid>
                  {passwordButton ? (
                    <Grid item xs={4}>
                      <Button
                        variant="contained"
                        sx={{ color: "#fff" }}
                        onClick={() => setPasswordButton(false)}
                      >
                        {" "}
                        Change Password
                      </Button>
                    </Grid>
                  ) : (
                    <Grid item xs={8}>
                      <Grid container spacing={3}>
                        <Grid item xs={5}>
                          <MDInput
                         onKeyDown={(e) => { e.key === 'Enter' && e.preventDefault() }}
                            placeholder="New Password"
                            sx={{ width: "100%", marginTop: "0.4rem" }}
                            inputProps={{
                              style: { fontSize: 15, fontWeight: "bold" },
                            }}
                            {...register("password")}
                            error={errors?.password?.message}
                            helperText={errors?.password?.message}
                          />
                        </Grid>
                        <Grid item xs={5}>
                          <MDInput
                          onKeyDown={(e) => { e.key === 'Enter' && e.preventDefault() }}
                            placeholder="Confirm New Password"
                            sx={{ width: "100%", marginTop: "0.4rem" }}
                            inputProps={{
                              style: { fontSize: 15, fontWeight: "bold" },
                            }}
                            {...register("confirmPassword")}
                            error={errors?.confirmPassword?.message}
                            helperText={errors?.confirmPassword?.message}
                          />
                        </Grid>
                        <Grid item xs={2}>
                          <Button
                            variant="contained"
                            sx={{ color: "#fff", marginTop: "0.4rem" }}
                            onClick={() => setPasswordButton(true)}
                          >
                            {" "}
                            Cancel
                          </Button>
                        </Grid>
                      </Grid>
                    </Grid>
                  )}

                  {/* Permission title */}
                  {/* <Grid item xs={12}>
                    <Typography variant="h4">Permissions</Typography>
                  </Grid> */}
                  {/* <Grid item xs={12}>
                    <Typography variant="h4">Permissions</Typography>
                  </Grid> */}
                  <Grid xs={16} ml={2} mt={2}>
                    {renderPermissionsTable()}

                    {/* {renderPermissionsTable(responseData?.permissions || [])} */}
                  </Grid>
                  {/* <Grid item xs={4}>
                    <Typography variant="subtitle1">Role</Typography>
                  </Grid>
                  <Grid item xs={8}>
                  <SelectDropDownNew
                control={control}
              name="role"
             
              defaultValue="none"
              options={roleOptions}
              getValues={getValues}
              placeholder="Select"
              customOnChange={(e)=>{
                setValue("role",e.target.value)
              }}

            />         
                  </Grid> */}

                  <Grid item xs={12} md={12}>
                    <FormGroup>
                      {/* <FormControlLabel
                        control={
                          <Controller
                            defaultValue={false}
                            name="isAdmin"
                            control={control}
                            render={({ field: props }) => (
                              <Checkbox
                                {...props}
                                checked={props.value}
                                {...register("isAdmin")}
                                onChange={(e) =>
                                  props.onChange(e.target.checked)
                                }
                              />
                            )}
                          />
                        }
                        label="Can Login to Admin?"
                      /> */}
                      <FormControlLabel
                        control={
                          <Controller
                            defaultValue={false}
                            name="isSuperAdmin"
                            control={control}
                            render={({ field: props }) => (
                              <Checkbox
                                {...props}
                                checked={props.value}
                                {...register("isSuperAdmin")}
                                onChange={(e) =>
                                  props.onChange(e.target.checked)
                                }
                              />
                            )}
                          />
                        }
                        label="Make User Super Admin"
                      />
                      <FormControlLabel
                        control={
                          <Controller
                            defaultValue={false}
                            name="accountDisable"
                            control={control}
                            render={({ field: props }) => (
                              <Checkbox
                                {...props}
                                checked={props.value}
                                {...register("accountDisable")}
                                onChange={(e) =>
                                  props.onChange(e.target.checked)
                                }
                              />
                            )}
                          />
                        }
                        label="Deactivate User"
                      />
                    </FormGroup>
                  </Grid>
                  {/* Meta */}
                  <Grid item xs={12}>
                    <Typography variant="h4">Meta</Typography>
                  </Grid>
                  <Grid item xs={4}>
                    <Typography
                      variant="subtitle1"
                      sx={{ width: "80%", marginTop: "0.8rem" }}
                    >
                      Created At
                    </Typography>
                  </Grid>
                  <Grid item xs={8}>
                    <MDInput
                      onKeyDown={(e) => {
                        e.key === "Enter" && e.preventDefault();
                      }}
                      disabled
                      placeholder="Created At"
                      sx={{ width: "100%", marginTop: "0.4rem" }}
                      inputProps={{
                        style: { fontSize: 15, fontWeight: "bold" },
                      }}
                      {...register("createdAt")}
                    />
                  </Grid>
                  <Grid item xs={4}>
                    <Typography
                      variant="subtitle1"
                      sx={{ width: "80%", marginTop: "0.8rem" }}
                    >
                      Updated At
                    </Typography>
                  </Grid>
                  <Grid item xs={8}>
                    <MDInput
                      onKeyDown={(e) => {
                        e.key === "Enter" && e.preventDefault();
                      }}
                      disabled
                      placeholder="Updated At"
                      sx={{ width: "100%", marginTop: "0.4rem" }}
                      inputProps={{
                        style: { fontSize: 15, fontWeight: "bold" },
                      }}
                      {...register("updatedAt")}
                    />
                  </Grid>
                </Grid>
                <div style={{ marginTop: "2rem" }}>
                  <Button
                    type="submit"
                    variant="contained"
                    sx={{ color: "#fff" }}
                  >
                    {" "}
                    Save
                  </Button>

                  {/* <Button
                    variant="outlined"
                    sx={{ color: "#111", marginLeft: "1rem" }}
                    onClick={handleReset}
                  >
                    Reset
                  </Button> */}
                </div>
              </form>
            </DialogContent>
          </MDBox>
        ) : (
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              marginBottom: "24%",
              marginTop: "20%",
            }}
          >
            <CircularProgress disableShrink />
          </div>
        )}
      </DashboardLayout>
    </>
  );
};
export default AdminUserForm;
